import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteCoachingAssignment = async (id: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteCoachingAssignment($id: ID!) {
        deleteCoachingAssignment(id: $id)
      }
    `),
    variables: { id },
  });
  return response.data?.deleteCoachingAssignment ?? false;
};
